// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  fillId: __t.u64().primaryKey().name("fill_id"),
  stationKey: __t.string().name("station_key"),
  familyKey: __t.string().name("family_key"),
  priceSov: __t.i64().name("price_sov"),
  qty: __t.u32(),
  buyer: __t.identity(),
  seller: __t.identity(),
  via: __t.string(),
  at: __t.timestamp(),
});
